"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineService = defineService;
exports.implementService = implementService;
function defineService(id) {
    return id;
}
function implementService(_, factory) {
    return factory;
}
implementService.withConfig = function () {
    return function (_, factory) {
        return factory;
    };
};
